import { Api } from "../../api"
import getStore from "../../store"
import { TUser } from "../@types/data/user"

/**
 * O pagamento passa pelo checkout sem login quando não há usuário nesta aba
 * ou quando ele é o visitante de uma compra anterior. Quem entrou com o
 * código segue como está.
 */
export const needsGuestCheckout = (
  user: Pick<TUser, "guest"> | null | undefined,
): boolean => !user || user.guest === true

/**
 * Checkout sem login: garante o cadastro do telefone no backend (sem código
 * e sem token) e guarda o comprador do formulário como visitante. PIX e
 * cartão leem `user.fone` para o buyTicket, que devolve o token do pedido.
 */
export const startGuestCheckout = async (buyer: {
  name: string
  phone: string
  email: string
}) => {
  const name = buyer.name.trim()
  const email = buyer.email.trim()

  const res = await Api.post.checkout.customer({ phone: buyer.phone, name, email })
  if (!res.ok) return res

  const guest = {
    name,
    email,
    fone: buyer.phone.replace(/\D/g, ""),
    guest: true,
  } as TUser

  sessionStorage.setItem("user", JSON.stringify(guest))
  getStore.getState().controllers.user.setData(guest)

  return res
}
